import React from "react";
import { AttributeType, StringSubType } from "@evergis/api";
import { Icon, IconTypesKeys } from "@evergis/ui";

import { HeaderPrefix } from "../modules/Table/styled";

export const getAttributePrefixIcon = (attributeName: string, type: AttributeType, subType: StringSubType) => {
  let iconKind: IconTypesKeys | undefined;

  if (attributeName !== "coordinates") {
    if ([AttributeType.Int32, AttributeType.Int64].includes(type)) {
      iconKind = "int";
    }

    if (type === AttributeType.Double) {
      iconKind = "double";
    }

    if (type === AttributeType.DateTime) {
      iconKind = "datetime";
    }

    if (type === AttributeType.String && subType !== StringSubType.Image) {
      iconKind = "text";
    }

    if (type === AttributeType.String && subType === StringSubType.Image) {
      iconKind = "image";
    }

    if (type === AttributeType.Json && subType === StringSubType.Attachments) {
      iconKind = "attachment";
    }
  } else {
    if ([AttributeType.Point, AttributeType.Multipoint].includes(type)) {
      iconKind = "geom_point";
    }

    if (type === AttributeType.MultiPolygon) {
      iconKind = "geom_polygon";
    }

    if (type === AttributeType.Polyline) {
      iconKind = "geom_polyline";
    }
  }

  return iconKind ? (
    <HeaderPrefix>
      <Icon kind={iconKind} />
      <Icon kind="sorting" />
    </HeaderPrefix>
  ) : null;
};
